import React, { Component } from "react";
import { connect } from "react-redux";

export default connect((state) => ({}))(
  class PrivacyPolicy extends Component {
    render() {
      const headingStyle = {
        fontStyle: "normal",
        letterSpacing: "0.16px",
        fontFamily: "Open Sans",
      };

      const bodyStyle = {
        fontStyle: "normal",
        fontSize: "14px",
        lineHeight: "24px",
        letterSpacing: "0.16px",
        fontFamily: "Open Sans",
      };
      const contentStyle = {
        fontStyle: "normal",
        fontSize: "16px",
        lineHeight: "24px",
        letterSpacing: "0.16px",
        fontFamily: "Open Sans",
        fontWeight: "bold",
        padding: "0",
        margin: "0",
      };

      return (
        <div>
          {this.props.location.search.indexOf("bp-no-header=true") === -1 && (
            <div>
              <div className="banner bg-img">
                <div className="contain" />
              </div>
            </div>
          )}
          <div className="contain">
            <div className="privacy-policy" style={{ color: "#858589" }}>
              <h3 style={{ textAlign: "center" }}>Privacy Policy</h3>
              <hr />
              <p>Last Modified: June 2022</p>
              <section>
                <p
                  style={{
                    fontStyle: "normal",
                    fontSize: "14px",
                    lineHeight: "24px",
                    letterSpacing: "0.16px",
                    fontFamily: "Open Sans",
                  }}
                >
                  <strong style={{ fontWeight: "bold" }}>
                    {" "}
                    Datapex Drifty Technologies
                  </strong>{" "}
                  Limited and its affiliates ("BuyPower" or "the Company")
                  operates Buypower.ng platform (the “Platform”). This Privacy
                  Policy informs you of the policies regarding the collection,
                  use and disclosure of Personal Information when you use the
                  Platform. We will not share your information with anyone
                  except as described in this Privacy Policy. We use your
                  personal information for providing and improving the services
                  on the Platform. By using the platform, you agree to the
                  collection and use of information in accordance with this
                  policy. Unless otherwise defined in this Privacy Policy, terms
                  used in this Privacy Policy have the same meanings as in our
                  Terms of Use. This Privacy Policy applies to all of our
                  services. By accessing or using our services, or otherwise
                  manifesting your assent to this Privacy Policy, you signify
                  that you have read, understood and agree to our collection,
                  storage, use and disclosure of your personal information as
                  described in this Privacy Policy and our Terms of Use. If you
                  are an individual acting on behalf of a Company, you represent
                  and warrant that you are an authorized representative of
                  Company with the authority to bind Company to this Privacy
                  Policy ("Administrator"), and that you agree to this Privacy
                  Policy on Company’s behalf.
                </p>
              </section>
              <section>
                <h4 style={contentStyle}>Content</h4>
                <p>
                  <ul
                    style={{
                      // remove the dotting
                      listStyleType: "none",
                      padding: "0",
                      margin: "0",
                    }}
                  >
                    <li>
                      <a href="#information-collection-and-use">
                        Information Collection and Use
                      </a>
                    </li>
                    <li>
                      <a href="#log-data">Log Data</a>
                    </li>
                    <li>
                      <a href="#location-information">Location Information</a>
                    </li>
                    <li>
                      <a href="#what-information-do-we-collect">
                        What information do we collect?
                      </a>
                    </li>
                    <li>
                      <a href="#purpose-for-collecting-data">
                        The purpose for which we will use your data
                      </a>
                    </li>
                    <li>
                      <a href="#information-we-receive-from-other-sources">
                        Information we receive from other sources
                      </a>
                    </li>
                    <li>
                      <a href="#cookies">Cookies</a>
                    </li>
                    <li>
                      <a href="#disclosure-of-your-information">
                        Disclosure of your information
                      </a>
                    </li>
                    <li>
                      <a href="#information-we-receive-from-other-sources">
                        Changes to Personal Information
                      </a>
                    </li>
                    <li>
                      <a href="#site-data">Site Data</a>
                    </li>
                    <li>
                      <a href="#third-party-tracking-and-online-advertising">
                        Third Party Tracking and Online Advertising
                      </a>
                    </li>
                    <li>
                      <a href="#security">Security</a>
                    </li>
                    <li>
                      <a href="#international-transfer">
                        International Transfer
                      </a>
                    </li>
                    <li>
                      <a href="#links-to-other-sites">Links to Other Sites</a>
                    </li>
                    <li>
                      <a href="#childrens-privacy">Children’s Privacy</a>
                    </li>
                    <li>
                      <a href="#your-legal-rights">Your legal rights</a>
                    </li>
                    <li>
                      <a href="#changes-to-this-privacy-policy">
                        Changes to This Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a href="#contact-us">Contact Us</a>
                    </li>
                  </ul>
                </p>
              </section>
              <section id="information-collection-and-use">
                <h4 style={headingStyle}>Information Collection and Use</h4>
                <p style={bodyStyle}>
                  While using our Platform, we may ask you to provide us with
                  certain personally identifiable information that can be used
                  to contact or identify you. Personally identifiable
                  information may include, but is not limited to, your email
                  address, name, phone number, postal address (“Personal
                  Information”).{" "}
                </p>
              </section>
              <section id="log-data">
                <h4 style={headingStyle}>Log Data</h4>
                <p style={bodyStyle}>
                  When you access the Platform by or through a mobile device, we
                  may collect certain information automatically, including, but
                  not limited to, the type of mobile device you use, your mobile
                  device unique ID, the IP address of your mobile device, your
                  mobile operating system, the type of internet mobile browser
                  you use, and other statistics (“Log Data”). In addition, we
                  may use third party platforms such as Google Analytics, that
                  collect, monitor and analyse this type of information in order
                  to increase our Platform’s functionality. These third-party
                  platform providers have their own privacy policies addressing
                  how they use such information.
                </p>
              </section>
              <section id="location-information">
                <h4 style={headingStyle}>Location Information</h4>
                <p style={bodyStyle}>
                  We may use and store information about your location, if you
                  give us permission to do so. We use this information to
                  provide features of our Platform, to improvise and customise
                  our Platform. You can enable or disable location Platform when
                  you use our Platform at any time, through your mobile device
                  settings.
                </p>
              </section>
              <section id="what-information-do-we-collect">
                <h4 style={headingStyle}>What information do we collect?</h4>
                <p style={bodyStyle}>
                  The categories of information we collect can include:
                  <ol
                    style={{
                      paddingLeft: "30px",
                      paddingTop: "10px",
                    }}
                  >
                    <li>
                      We will collect business and financial information as a
                      prerequisite to you being authorised to use the Platform
                      to open an account. The collection of business information
                      may include, but is not limited to, your business name,
                      tax identification number, business address, business
                      telephone number, business bank account information,
                      business related documentation, and email address. In
                      addition, the beneficial owners of the business will be
                      required to provide personal information including, but
                      not limited to their; name, address, date of birth,
                      National Identification Number (NIN), telephone number, a
                      photo of their international passport or driver's licence,
                      and other similar information. Additional information will
                      be requested at account opening and may be requested
                      throughout the life of the account relationship to meet
                      regulatory and legal requirements.
                    </li>
                    <li>
                      Data collected through the use of the Platform. We collect
                      information about how you use the Platform, your actions
                      on the Platform, and your communications with us through
                      the Platform. If you need to update your permissions, you
                      can do so in the "Settings'' app of your device. Please
                      remember that Payable may, but has no obligation to,
                      monitor, record, and store information you provide to
                      Payable and information we collect about you in order to
                      protect your safety or the safety of other users, to
                      assist with regulatory or law enforcement efforts, or to
                      protect and defend our rights and property. By using the
                      Service, you consent to the recording, storage and
                      disclosure of such communications you send or receive for
                      these purposes
                    </li>
                    <li>
                      The Central Bank of Nigeria (Anti-money Laundering and
                      Combating the Financing of Terrorism and Countering
                      Proliferation Financing of Weapons of Mass Destruction in
                      Financial in Financial Institutions) Regulations, 2022
                      (AML/CFT Regulation, which helps the government fight the
                      funding of terrorism and money laundering activities,,
                      requires financial institutions to obtain, verify, and
                      record information that identifies each business that
                      opens an account and the personal information of its
                      owners or representatives. Bear in mind that when applying
                      for an account, we will ask for the following details on
                      behalf of financial institution(s);
                      <ul style={{ padding: "5px 0px" }}>
                        <li>
                          The personally identifiable information about the
                          business owners, administrators, and/or authorised
                          users such as: name, address, date of birth, NIN,
                          telephone number, and other information that will
                          allow financial institution(s) to confirm your
                          identity.
                        </li>
                        <li>
                          We may also ask for details about the business
                          owner’s, administrators’, and/or authorised user’s
                          driver’s licence number, international passport
                          information, or other identifying information.
                        </li>
                        <li>
                          We may also collect photos, text, videos, or any other
                          information you upload and/or send through our
                          Platform
                        </li>
                      </ul>
                    </li>
                    <li>
                      Information collected from your device when you use our
                      Platform, we may collect information from your computer or
                      mobile device, such as the unique identification number,
                      the model, operating system and version, your browser type
                      and version, the presence of any device, operating system,
                      or browser add-ons, the times you access our Services, the
                      locations from where you access our Services (attributed
                      based on your IP address, the page you visited before
                      navigating to our Services, and your mobile device’s
                      location services), and your stored contacts.
                    </li>
                  </ol>
                </p>
              </section>
              <section id="purpose-for-collecting-data">
                <h4 style={headingStyle}>
                  The purpose for which we will use your data
                </h4>
                <p style={bodyStyle}>
                  We may use information held about you in the following ways:
                  <ol
                    style={{
                      paddingLeft: "30px",
                      paddingTop: "10px",
                    }}
                  >
                    <li>
                      To carry out our obligations arising from any contract
                      entered into between you and us, and to provide you with
                      the information, products and Platform that you request
                      from us;
                    </li>
                    <li>
                      To provide you with information about other goods and
                      Platforms we offer that are similar to those that you have
                      already purchased or enquired about;
                    </li>
                    <li>
                      To provide you, or permit selected third parties to
                      provide you, with information about goods or Platforms we
                      feel may interest you. If you are an existing customer, we
                      will only contact you by electronic means (e-mail or SMS)
                      with information about goods and Platforms similar to
                      those which were the subject of a previous sale or
                      negotiations of sale to you. If you are a new customer,
                      and where we permit selected third parties to use your
                      data, we (or they) will contact you by electronic means
                      only if you have consented to this. If you do not want us
                      to use your data in this way, or to pass your details onto
                      third parties for marketing purposes, please tick the
                      relevant box situated on the form on which we collect your
                      data;
                    </li>
                    <li>
                      To ensure that content from our site is presented in the
                      most effective manner for you and to notify you about
                      changes to our Platform;
                    </li>
                    <li>
                      To administer our site for internal operations, including
                      troubleshooting, data analysis, testing, research,
                      statistical and survey purposes;
                    </li>
                    <li>
                      To measure or understand the effectiveness of advertising
                      we send to you and others, and to deliver relevant
                      advertising to you;
                    </li>
                    <li>
                      To make suggestions and recommendations to you and other
                      users of our sites about goods or Platforms that may
                      interest you or them, identify your preferences and
                      personalise your experience with the Platform;
                    </li>
                  </ol>
                </p>
              </section>
              <section id="information-we-receive-from-other-sources">
                <h4 style={headingStyle}>
                  Information we receive from other sources
                </h4>
                <p style={bodyStyle}>
                  We will combine this information with the information you give
                  to us and the information we collect about you. We will use
                  this information and the combined information for the purposes
                  set out above (depending on the type of information we
                  receive). We may also send you Platform-related emails or
                  messages (e.g. account verification, change or updates to
                  features of the Platform, technical and security notices). For
                  more information about your communication preferences, see
                  "Control Over Your Information" below
                </p>
              </section>
              <section id="cookies">
                <h4 style={headingStyle}>Cookies</h4>
                <p style={bodyStyle}>
                  Cookies are small packets of data that a website stores on
                  your computer’s or mobile device’s hard drive (or other
                  storage medium) so that your computer will "remember"
                  information about your use. Cookies are sent to your browser
                  from a website and stored on your computer’s hard drive.
                  <br />
                  We use cookies for the following purposes
                  <ol
                    style={{
                      padding: "10px 0px 10px 30px",
                    }}
                  >
                    <li>To enhance your user experience on our Platform.</li>
                    <li>To recognise new or past customers.</li>
                    <li>
                      To store your password if you are registered on our
                      Platform.
                    </li>
                    <li>
                      To monitor and improve the effectiveness of our Platform
                      and to better understand your visits on our Platforms.
                    </li>
                    <li>
                      To serve you with interest-based or targeted advertising.
                    </li>
                    <li>
                      To observe your behaviours or browsing activities over
                      time across multiple Platforms or other platforms.
                    </li>
                    <li>
                      To better understand the interest of our customers and
                      visitors to our Platform.
                    </li>
                    <li>
                      To diagnose or fix technical issues, to plan for and
                      enhance our Platform
                    </li>
                  </ol>
                  If you would prefer not to accept cookies, most browsers will
                  allow you to:
                  <ol style={{ paddingBottom: "5px", paddingTop: "5px" }}>
                    <li>
                      Change your browser settings to notify you when you
                      receive a cookie, which lets you choose whether or not to
                      accept it;
                    </li>
                    <li>Disable existing cookies;</li>
                    <li>Set your browser to automatically reject cookies;</li>
                  </ol>
                  Please note that doing so may negatively impact your
                  experience using the Platform, as some features and services
                  on our Platform may not work properly. Depending on your
                  mobile device and operating system, you may not be able to
                  delete or block all cookies. You may also set your email
                  options to prevent the automatic downloading of images that
                  may contain technologies that would allow us to know whether
                  you have accessed our email and performed certain functions
                  with it.
                  <br />
                  <br />
                  Note that deleting cookies does not delete Local Storage
                  Objects (LSOs) such as Flash objects and HTML5.
                  <br />
                  <br />
                  We and our third-party partners may also use cookies and
                  tracking technologies for advertising purposes. For more
                  information about tracking technologies, please see "Third
                  Party Tracking and Online Advertising" below.
                </p>
              </section>
              <section id="disclosure-of-your-information">
                <h4 style={headingStyle}>Disclosure of your information</h4>
                <p style={bodyStyle}>
                  You agree that we have the right to share your personal
                  information
                  <ol
                    style={{
                      padding: "10px 0px 10px 30px",
                    }}
                  >
                    <li>
                      With any of our affiliated companies and Platform
                      providers;
                    </li>
                    <li>
                      With financial Platform providers, including the financial
                      institutions identified in your cardholder bank agreement
                      that provide banking Platforms in connection with your
                      account;
                    </li>
                    <li>
                      With non-financial companies, such as email Platform
                      providers that perform marketing Platforms on our behalf,
                      and fraud prevention Platform providers that use the
                      information to provide Platforms to us;
                    </li>
                    <li>
                      With a non-affiliated third-party to access and transmit
                      your personal and financial information from a relevant
                      financial institution. You grant the third- party the
                      right, power, and authority to access and transmit this
                      information according to terms of their privacy policy;
                    </li>
                    <li>
                      With selected third parties including business partners,
                      suppliers and subcontractors for the performance of any
                      contract we enter into with them or you;
                    </li>
                    <li>
                      With third parties to whom we may choose to sell, transfer
                      or merge parts of our business or our assets or
                      alternatively, acquire all or parts of their businesses;
                    </li>
                    <li>
                      In response to a request for information, if we are
                      required by, or we believe disclosure is in accordance
                      with, any applicable law, regulation or legal process;
                    </li>
                    <li>
                      With relevant law enforcement officials or other third
                      parties, such as investigators or auditors, if we believe
                      it is appropriate to investigate fraud.
                    </li>
                    <li>
                      Other parties in connection with a company transaction,
                      such as a merger, sale of company assets or shares,
                      reorganisation, financing, change of control or
                      acquisition of all or a portion of our business by another
                      company or third party, or in the event of a bankruptcy or
                      related or similar proceedings; and
                    </li>
                    <li>
                      10.We may also share information with others in an
                      aggregated or otherwise anonymized form that does not
                      reasonably identify you directly as an individual.
                    </li>
                  </ol>
                </p>
              </section>
              <section id="information-we-receive-from-other-sources">
                <h4 style={headingStyle}>Changes to Personal Information</h4>
                <p style={bodyStyle}>
                  Profile and Data Sharing Settings. You may update your profile
                  information, such as your username and profile photo, and may
                  change some of your data sharing preferences on your Settings
                  Page.
                  <br />
                  <br />
                  Access to your Device Information. You may control the app’s
                  access to your device information through your "Settings" app
                  on your device. For instance, you can withdraw permission for
                  the app to access your address book, location, photo stream
                  and camera.
                  <br />
                  <br />
                  How to control your communications preferences: You can stop
                  receiving promotional email communications from us by clicking
                  on the "unsubscribe link" provided in such communications. We
                  make every effort to promptly process all unsubscribe
                  requests. You may not opt out of service-related
                  communications (e.g., account verification, transactional
                  communications, changes/updates to features of the Service,
                  technical and security notices).
                  <br />
                  <br />
                  Modifying or deleting your information: If you have any
                  questions about reviewing, modifying, or deleting your
                  information, or if you want to remove your name or comments
                  from our website or publicly displayed content, you can
                  contact us directly at{" "}
                  <a href="mailto:support@buypower.ng">support@buypower.ng</a>.
                  We may not be able to modify or delete your information in all
                  circumstances
                </p>
              </section>
              <section id="site-data">
                <h4 style={headingStyle}>Site Data</h4>
                <p style={bodyStyle}>
                  In an ongoing effort to better understand our users and the
                  Platform, we might analyse site data to operate, maintain,
                  manage, and improve the Platform. This site data does not
                  identify you personally. We may share this aggregate data with
                  our affiliates, agents, and business partners. We may also
                  disclose site data and aggregate user statistics to describe
                  the Platform to current and prospective business partners and
                  to other third parties for other lawful purposes.
                </p>
              </section>
              <section id="third-party-tracking-and-online-advertising">
                <h4 style={headingStyle}>
                  Third Party Tracking and Online Advertising
                </h4>
                <p style={bodyStyle}>
                  We may share, or we may permit third party online advertising
                  networks, social media companies and other third-party
                  services, to collect, information about your use of our
                  website over time so that they may play or display
                  advertisement that may be relevant to your interests on our
                  Platform as well as on other websites or apps, or on other
                  devices you may use. This information is used to display
                  targeted adverts through our Platform or on other websites or
                  apps, including Facebook. We or the online advertising
                  networks use this information to make the advertisements you
                  see online more relevant to your interests. As noted above,
                  depending on your browser or mobile device, you may be able to
                  set your browser to delete or notify you of cookies and other
                  tracking technology by actively managing the settings on your
                  browser or mobile device. You may also be able to limit
                  interest-based advertising through the settings on your mobile
                  device by selecting "limit ad tracking" (iOS) or "opt-out of
                  interest-based ads" (Android). If you have any questions about
                  opting out of the collection of cookies and other
                  tracking/recording tools, you can contact us directly at{" "}
                  <a href="mailto:support@buypower.ng">support@buypower.ng</a>
                  <br />
                  <br />
                  We may work with Facebook to display interest-based ads to you
                  or to your friends on Facebook through the Custom Audience
                  Tool. This tool allows us to personalise our ads based on you
                  or your friends’ experience on our Platform in order to
                  provide ads tailored for each specific recipient. We do not
                  share personal information about your activities on our
                  Platform with Facebook, but we share a hashed email address or
                  phone number which permits Facebook to identify our
                  advertising audience based on the information that Facebook
                  collects from its users. If you do not want to receive
                  interest-based ads on Facebook, you can adjust your ad
                  preferences through your Facebook settings. If you do not want
                  us to use your content to personalise advertising that we
                  direct to your friends on Facebook, you may email us at{" "}
                  <a href="mailto:support@buypower.ng">support@buypower.ng</a>
                </p>
              </section>
              <section id="how-we-store-and-protect-your-information">
                <h4 style={headingStyle}>
                  How We Store and Protect Your Information
                </h4>
                <p style={bodyStyle}>
                  Data storage and transfer: Your information collected through
                  our Services may be stored and processed in Nigeria or any
                  other country in which Payable or its affiliates or service
                  providers maintain facilities. If you are located in the
                  European Union or other regions with laws governing data
                  collection and use that may differ from Nigeria law, please
                  note that we may transfer information, including personal
                  information, to a country and jurisdiction that does not have
                  the same data protection laws as your jurisdiction, and you
                  acknowledge such transfer of information to Nigeria or any
                  other country in which the Payable or its parent,
                  subsidiaries, affiliates, or service providers maintain
                  facilities and the use and disclosure of information about you
                  as described in this Privacy Policy.
                  <br />
                  <br />
                  Keeping your information safe: We care about the security of
                  your information and use commercially reasonable physical,
                  administrative, and technological safeguards to preserve the
                  integrity and security of all information collected through
                  our Services. However, no security system is impenetrable and
                  we cannot guarantee the security of our systems or the systems
                  of the third parties with which we may share your information,
                  nor can we guarantee that the information you supply will not
                  be intercepted while being transmitted over the Internet. In
                  particular, e-mail sent to us may not be secure, and you
                  should therefore take special care in deciding what
                  information you send to us via e-mail.
                </p>
              </section>
              <section id="communications">
                <h4 style={headingStyle}>Communications</h4>
                <p style={bodyStyle}>
                  We may use your Personal Information to contact you with
                  newsletters, marketing or promotional materials and other
                  information that may be of interest to you. You may opt out of
                  receiving any, or all, of these communications from us by
                  following the unsubscribe link or instructions provided in any
                  email we send.
                </p>
              </section>
              <section id="compliance-with-laws">
                <h4 style={headingStyle}>Compliance with Laws</h4>
                <p style={bodyStyle}>
                  We will disclose your Personal Information where required to
                  do so by law or subpoena or if we believe that such action is
                  necessary to comply with the law and the reasonable requests
                  of law enforcement or to protect the security or integrity of
                  our Platform.
                </p>
              </section>
              <section id="business-transaction">
                <h4 style={headingStyle}>Business Transaction</h4>
                <p style={bodyStyle}>
                  If Datapex Drifty Technologies Limited is involved in a
                  merger, acquisition or asset sale, your Personal Information
                  may be transferred. We will provide notice before your
                  Personal Information is transferred and becomes subject to a
                  different Privacy Policy.
                </p>
              </section>
              <section id="security-and-retention">
                <h4 style={headingStyle}>Security and Retention</h4>
                <p style={bodyStyle}>
                  The security of your Personal Information is important to us,
                  but remember that no method of transmission over the Internet,
                  or method of electronic storage is 100% secure. While we
                  strive to use commercially acceptable means to protect your
                  Personal Information, we cannot guarantee its absolute
                  security. We will retain your data for as long as necessary
                  for the said purpose of the processing, and after that, we
                  will keep your data as long as the law requires.
                </p>
              </section>
              <section id="international-transfer">
                <h4 style={headingStyle}>International Transfer</h4>
                <p style={bodyStyle}>
                  Your information, including Personal Information, may be
                  transferred to — and maintained on — computers located outside
                  of your state, province, country or other governmental
                  jurisdiction where the data protection laws may differ from
                  those from your jurisdiction. If you are located outside
                  Nigeria and choose to provide information to us, please note
                  that we transfer the information, including Personal
                  Information, to Nigeria and process it there. Your consent to
                  this Privacy Policy followed by your submission of such
                  information represents your agreement to that transfer.
                </p>
              </section>
              <section id="links-to-other-sites">
                <h4 style={headingStyle}>Links To Other Sites</h4>
                <p style={bodyStyle}>
                  Our Platform may contain links to other sites that are not
                  operated by us. If you click on a third-party link, you will
                  be directed to that third party's site. We strongly advise you
                  to review the Privacy Policy of every site you visit. We have
                  no control over, and assume no responsibility for the content,
                  privacy policies or practices of any third-party sites or
                  Platforms.
                </p>
              </section>
              <section id="childrens-privacy">
                <h4 style={headingStyle}>Children's Privacy</h4>
                <p style={bodyStyle}>
                  Our Platform does not address anyone under the age of 18 years
                  ("Children"). We do not knowingly collect personally
                  identifiable information from children under 18. If you are a
                  parent or guardian and you are aware that your Children has
                  provided us with Personal Information, please contact us. If
                  we become aware that we have collected Personal Information
                  from a child under the age of 18 years without verification of
                  parental consent, we take steps to remove that information
                  from our servers. If you believe that we might have any
                  information from a child under the age of 18 years, please
                  contact us at{" "}
                  <a href="mailto:support@buypower.ng">support@buypower.ng</a>
                </p>
              </section>
              <section id="your-legal-rights">
                <h4 style={headingStyle}>Your Legal Rights</h4>
                <p style={bodyStyle}>
                  You have the right to:
                  <ol
                    style={{
                      padding: "10px 0px 10px 30px",
                    }}
                  >
                    <li>
                      Request access to your personal data (commonly known as a
                      “data subject access request”). This enables you to
                      receive a copy of the personal data we hold about you and
                      to check that we are lawfully processing it.
                    </li>
                    <li>
                      Request correction of the personal data that we hold about
                      you. This enables you to have any incomplete or inaccurate
                      data we hold about you corrected, though we may need to
                      verify the accuracy of the new data you provide to us.
                    </li>
                    <li>
                      Request erasure of your personal data. This enables you to
                      ask us to delete or remove personal data where there is no
                      good reason for us continuing to process it. You also have
                      the right to ask us to delete or remove your personal data
                      where you have successfully exercised your right to object
                      to processing (see below), where we may have processed
                      your information unlawfully or where we are required to
                      erase your personal data to comply with local law. Note,
                      however, that we may not always be able to comply with
                      your request of erasure for specific legal reasons which
                      will be notified to you, if applicable, at the time of
                      your request.
                    </li>
                    <li>
                      Object to processing of your personal data where we are
                      relying on a legitimate interest (or those of a third
                      party) and there is something about your particular
                      situation which makes you want to object to processing on
                      this ground as you feel it impacts on your fundamental
                      rights and freedoms. You also have the right to object
                      where we are processing your personal data for direct
                      marketing purposes. In some cases, we may demonstrate that
                      we have compelling legitimate grounds to process your
                      information which override your rights and freedoms.
                    </li>
                    <li>
                      Request restriction of processing of your personal data.
                      This enables you to ask us to suspend the processing of
                      your personal data in the following scenarios.
                    </li>
                    <li>If you want us to establish the data’s accuracy.</li>
                    <li>
                      Where our use of the data is unlawful but you do not want
                      us to erase it.
                    </li>
                    <li>
                      Where you need us to hold the data even if we no longer
                      require it as you need it to establish, exercise or defend
                      legal claims.
                    </li>
                    <li>
                      You have objected to our use of your data but we need to
                      verify whether we have overriding legitimate grounds to
                      use it.
                    </li>
                    <li>
                      10.Request the transfer of your personal data to you or to
                      a third party. We will provide to you, or a third party
                      you have chosen, your personal data in a structured,
                      commonly used, machine-readable format. Note that this
                      right only applies to automated information which you
                      initially provided consent for us to use or where we used
                      the information to perform a contract with you.
                    </li>
                    <li>
                      Withdraw consent at any time where we are relying on
                      consent to process your personal data. However, this will
                      not affect the lawfulness of any processing carried out
                      before you withdraw your consent. If you withdraw your
                      consent, we may not be able to provide certain products or
                      Platforms to you. We will advise you if this is the case
                      at the time you withdraw your consent
                    </li>
                  </ol>
                </p>
              </section>
              <section id="changes-to-our-privacy-policy">
                <h4 style={headingStyle}>Changes To Our Privacy Policy</h4>
                <p style={bodyStyle}>
                  We may update our Privacy Policy from time to time. We will
                  notify you of any changes by posting the new Privacy Policy on
                  this page. You are advised to review this Privacy Policy
                  periodically for any changes. Changes to this Privacy Policy
                  are effective when they are posted on this page.
                </p>
              </section>
              <section id="changes-to-our-privacy-policy">
                <h4 style={headingStyle}>How to Contact Us</h4>
                <p style={bodyStyle}>
                  If you have any questions about this Privacy Policy or the
                  website, please contact us at{" "}
                  <a href="mailto:support@buypower.ng">support@buypower.ng</a>
                </p>
              </section>
            </div>
          </div>
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy.js